module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-wrap"
  }, [_c('div', {
    staticClass: "wrap_a"
  }, [_c('h3', {
    on: {
      "click": function($event) {
        _vm.load()
      }
    }
  }, [_vm._v("本周流行")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('ul', {
    staticClass: "list_log clearfix"
  }, _vm._l((_vm.news), function(n) {
    return _c('li', [_c('a', {
      directives: [{
        name: "vid",
        rawName: "v-vid",
        value: (n.link),
        expression: "n.link"
      }]
    }, [_c('div', {
      staticClass: "list_a"
    }, [_c('img', {
      attrs: {
        "src": n.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "list_b"
    }, [_vm._v(_vm._s(n.title))])])])
  }))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-67700f46", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-67700f46","hasScoped":true}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./app/component/xcategary.vue
// module id = 150
// module chunks = 0